import React from 'react';
import styled from 'styled-components';

// StyledAgentMention renders a completed mention (an atomic inline element). The text child holds the
// "@Name" display text; the agent id lives on element.attributes['data-agentid'] for serialization.
export default function AgentMention(props) {
  const { attributes, children, element } = props;
  return (
    <StyledAgentMention {...attributes} data-agentid={element.attributes?.['data-agentid']}>
      {children}
    </StyledAgentMention>
  );
}

export const StyledAgentMention = styled.span.attrs({ 'data-aid': 'slate-agent-mention' })`
  background-color: ${p => p.theme.colors.gray100};
  border-radius: 4px;
  color: ${p => p.theme.colors.green400};
  font-weight: bold;
  padding: 4px;

  &:hover {
    background-color: ${p => p.theme.colors.gray200};
  }
`;
